import React from 'react';
import { SvgIcon } from '@agilize/components-core';
import { ButtonFloatingWhatsapp } from './whatsappButton.styles';

// import { Container } from './styles';
interface WhatsappChatButtonProps {
  phoneNumber: string;
  countryCode: string;
  message?: string;
  callback?: () => void;
  animated: boolean;
}
const WhatsappChatButton = (props: WhatsappChatButtonProps) => {
  const { phoneNumber, countryCode, message, callback, animated } = props;
  if (!phoneNumber || !countryCode) {
    return null;
  }
  let URL = `https://wa.me/${countryCode}${phoneNumber}`;

  if (message) {
    URL += `?text=${encodeURI(message)}`;
  }
  return (
    <a
      onClick={() => {
        if (typeof callback === 'function') {
          callback();
        }
      }}
      className={`btn-floating-whatsapp ${animated && 'btn-floating-whatsapp__animated'}`}
      href={URL}
      target="_blank"
      rel="noreferrer">
      <ButtonFloatingWhatsapp>
        <SvgIcon width={80} height={80} src={`${process.env.APP_PATH}public/assets/icons/unicons/whatsapp-icon.svg`} />
        {/* <Button size="small" type="button" variant="text"></Button> */}
      </ButtonFloatingWhatsapp>
    </a>
  );
};

export default WhatsappChatButton;
